<template lang="pug">
  #messages
    WtTile(parent)
      WtTile(
        v-if="hasMessages"
        child
      )
        .level.is-mobile.mark-read-button
          .level-left
            .level-item
              .subtitle YOUR MESSAGES:
          .level-right
            .level-item
              WtButton(
                :disabled="messageCount < 1"
                @click.native.stop="markAllRead"
                is-text
              ) MARK ALL READ
        hr.navbar-divider
        template(v-for="message in styleMessages")
            RouterLink.message-text(
              :to="message.route"
              @click.native.stop="markRead(message)"
            )
              .columns.is-mobile
                .column.is-narrow
                  .icon-container
                    EntityAvatar(
                      v-if="showOriginator(message)"
                      :image="message.originator.avatar"
                      size-class="is-24x24"
                    )
                    BIcon(
                      v-else
                      :icon="icon(message)"
                      :type="message.active ? '' : 'is-lightgrey'"
                    )
                .column(:class="message.class") {{ date(message.created, "DATE_FORMAT_SLASH").formatted }}
                  span.padding-left {{ message.message }}
        WtTile(
          v-if="showPagination"
          child
          )
            .level
              WtPagination.level-item.is-fullwidth(
                :pagination-object="messages.pagination"
                :action="loadMore"
              )
      BTooltip.navbar-link.is-arrowless(
        v-else
        label="You don't have any messages!"
        position="is-left"
        type="is-dark"
        animated
      )
        .navbar-link.is-arrowless
          BIcon(icon="email-outline")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";
import WtPagination from "@@/WtPagination/WtPagination";
import WtTile from "@@/WtTile/WtTile.vue";

export default {
  name: "Messages",

  components: { WtPagination, EntityAvatar, WtButton, WtTile },

  mixins: [dateUtilityMixin],

  computed: {
    ...mapGetters("members", ["messageCount", "messages"]),

    totalPages() {
      return this._.get(this.messages, "pagination.totalPages", 0);
    },

    currentPage() {
      return this._.get(this.messages, "pagination.currentPage", 1);
    },

    showPagination() {
      return this.totalPages > 1;
    },

    styleMessages() {
      // add a class key to the object, and if active, set it to bold
      if (this.messages.data && this.messages.data.length > 0) {
        return this.messages.data.map(message => ({
          ...message,
          class: message.active
            ? "has-text-weight-bold has-text-danger"
            : "has-text-grey"
        }));
      }

      return [];
    },

    hasMessages() {
      return this.styleMessages.length > 0;
    }
  },

  mounted() {
    this.fetchMessages({ memberId: this.$auth.user().id });
  },

  methods: {
    ...mapActions("members", [
      "markMessageRead",
      "fetchMessages",
      "markAllMessagesRead"
    ]),

    backToFirstPage(bool) {
      // refetch to page 1 when dropdown closed and were on a different page
      if (!bool && this.currentPage !== 1) {
        this.fetchMessages({ memberId: this.$auth.user().id });
      }
    },

    loadMore(event) {
      this.fetchMessages({
        memberId: this.$auth.user().id,
        page: event
      });
    },

    markRead(message) {
      if (message.active) {
        this.textClass(message.id, false);
        return this.markMessageRead(message.id);
      }
    },

    markAllRead() {
      this.messages.data.forEach(message => {
        if (message.active) {
          this.textClass(message.id, false);
        }
      });
      return this.markAllMessagesRead({ memberId: this.$auth.user().id });
    },

    textClass(messageId, active) {
      const message = this.styleMessages.find(message => {
        return message.id === messageId;
      });
      // make the text bold if the message is "active" or unread
      const style = active
        ? "has-text-weight-bold has-text-danger"
        : "has-text-grey";

      message.active = false;
      return (message.class = style);
    },

    showOriginator(message) {
      const originatorTypes = [
        "journalreply",
        "spouseinvite",
        "spouseadd",
        "comradeinvite",
        "comradeadd"
      ];
      if (originatorTypes.includes(message.type)) {
        return message.originator && message.originator.id;
      }
      return false;
    },

    icon(message) {
      switch (message.type) {
        case "badgeissued":
          return "trophy";
        case "competitionjoin":
        case "competitioninvite":
        case "competitionending":
        case "discussionreply":
        case "joinrequest":
          // challenge related icon
          return "map-clock";
        case "groupinvite":
        case "groupjoin":
          // team related icon
          return "account-multiple";
        case "milestonepassed":
          // milestone related icon
          return "map-marker-check";
        case "newadmin":
          // admin related icon
          return "settings";
        default:
          return "map-marker";
      }
    }
  }
};
</script>

<style lang="sass">
#messages
  .padding-left
    padding-left: 10px

  .icon-container
    .icon
      margin: 0

  .counter
    top: -.6rem
    right: .3rem
    position: relative
    height: 1rem
    width: auto // opt for pill style instead of circle, which IE11 also likes
    padding: .6rem

  .messages-dropdown
    .dropdown-menu
      width: 30rem
      +mobile
        width: 88%
      .dropdown-content
        .column
          flex-basis: auto !important // IE11 fix
        .dropdown-item
        .has-link
          a
            white-space: normal
      .pagination
        margin-top: 0
</style>
